import { en, swe, no } from './languages/list';
const appConfig = ($translateProvider, $locationProvider, $compileProvider) => {
    $locationProvider.html5Mode(false);

    let debugMode = true;
    let preferredLanguage = '';

    if (window.location.hostname.slice(-3) === '.se') {
        preferredLanguage = 'swe';
    }
    if (window.location.hostname.slice(-3) === '.no') {
        preferredLanguage = 'no';
    }

    if (
        window.location.hostname.indexOf('nordiskafonster.se') !== -1 ||
        window.location.hostname.indexOf('nordiskavinduer.no') !== -1
    ) {
        debugMode = false;
    }

    $translateProvider
        .translations('en', en)
        .translations('swe', swe)
        .translations('no', no)
        .preferredLanguage(preferredLanguage)
        .useSanitizeValueStrategy(null);

    $compileProvider.debugInfoEnabled(debugMode);
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
};

appConfig.$inject = ['$translateProvider', '$locationProvider', '$compileProvider'];

export default appConfig;
